import { useState, useEffect } from 'react'
import { AnimatePresence } from 'framer-motion'

import * as S from './styles'
import Info from './animations/info.json'
import Error from './animations/error.json'
import Success from './animations/success.json'
import { Button } from 'src/components/Button'
import { ButtonContainer } from 'src/components/ButtonContainer'

interface IToastBaseProps {
  id?: string
  type?: 'error' | 'info' | 'success'
  title?: string
  message?: string
  children?: React.ReactNode
  isIndeterminate?: boolean
  textButton?: string
  customButton?: string
  onClick?: () => void
  onClose?: () => void
}

const ToastBase = ({
  id,
  type = 'info',
  title,
  message,
  children,
  isIndeterminate,
  textButton = 'Fechar',
  customButton,
  onClick,
  onClose,
}: IToastBaseProps) => {
  const [progress, setProgress] = useState(isIndeterminate ? 100 : 0)
  const animations = {
    info: Info,
    success: Success,
    error: Error,
  }
  const animation = animations[type]

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100 && !isIndeterminate) onClose && onClose()

        const diff = 1
        return Math.min(oldProgress + diff, 100)
      })
    }, 200)

    return () => clearInterval(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <AnimatePresence>
      <S.Wrapper
        id={id}
        key={id}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <S.LinearProgress variant="determinate" value={progress} type={type} />

        <S.ContentWrapper>
          <S.Content>
            {message ? (
              <div>
                <S.Title type={type}>{title || ''}</S.Title>
                <S.Message>{message}</S.Message>
              </div>
            ) : (
              <div>{children}</div>
            )}

            <ButtonContainer justifyContent="flex-start">
              <Button
                key={id}
                onClick={() => {
                  onClose && onClose()
                  onClick && onClick()
                }}
                data-testid="buttonClick"
              >
                {textButton}
              </Button>

              {customButton}
            </ButtonContainer>
          </S.Content>

          <S.LottieAnimation
            animationData={animation}
            autoplay={true}
            loop={true}
          />
        </S.ContentWrapper>
      </S.Wrapper>
    </AnimatePresence>
  )
}

export { ToastBase }
export type { IToastBaseProps }
